import { render } from "./RegiNoticeForm.vue?vue&type=template&id=8ccc90ac"
import script from "./RegiNoticeForm.vue?vue&type=script&lang=js"
export * from "./RegiNoticeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__